import API from '@aws-amplify/api';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import './Reports.scss';

function Reports() {
    const [t] = useTranslation();

    useEffect(() => {
        (async () => {
            let response = await API.get('ShipyardAPI', '/reports');
            console.log('API Gateway responded with', response);
        })();
    }, []);

    return <div>{t('Reports.Placeholder')}</div>;
}

export default Reports;
